import { RootState } from "../../store/store";
import { Button } from "@mantine/core";
import { useAppSelector } from "../../hooks/hooks";
import { Link } from "react-router-dom";


interface PermissionButtonProps {
   children?: React.ReactNode;
  resourceId: string;
  actionType: "create" | "read" | "update" | "delete";
  label?: string;
  className?: string;
  onClick?: () => void;
  to?: string; // Optional link destination
  target?: "_self" | "_blank"; // Optional target attribute
  loading?: boolean; // Optional loading state
  type?: "button" | "submit" | "reset"; // Valid button types
  disabled?: boolean; // Disable button manually
  variant?: string; // Mantine button variant
  form?:string
}

const PermissionButton: React.FC<PermissionButtonProps> = ({
  resourceId,
  actionType,
  label = "Permission",
  className = "btn-primary",
  onClick,
  to,
  target = "_self",
  loading = false,
  type = "button", // Default to "button"
  disabled = false,
  variant = "filled", // Default variant
  form,
}) => {
  const { permissions, loading: stateLoading } = useAppSelector((state: RootState) => state.permissions);

  const isLoading = stateLoading || loading;

  if (isLoading) return <p>Loading...</p>;

  const resource = permissions?.[resourceId]; // Fetch resource object
  const hasPermission = resource?.[actionType] || false;

  if (!hasPermission) return null; // Hide button if no permission

  return to ? (
    <Button
      component={Link}
      to={to}
      target={target}
      className={className}
      disabled={isLoading || disabled}
      variant={variant}
      loading={isLoading}
    >
      {label}
    </Button>
  ) : (
    <Button
      className={className}
      onClick={onClick}
      disabled={isLoading || disabled}
      type={type}
      variant={variant}
      loading={isLoading}
      form={form}          // <-- IMPORTANT

    >
      {label}
    </Button>
  );
};

export default PermissionButton;



//example for button
{/* <PermissionButton
  resourceId="123"
  actionType="create"
  label="Create"
  onClick={() => console.log("Button clicked!")}
  type="submit"
  loading={true}
/> */}

//example for link
{/* <PermissionButton
  resourceId="123"
  actionType="create"
  label="Go to Page"
  to="/addmemberpage"
  target="_self"
/> */}